/**
 * @file コンポーネント：フル動画ページノートボタン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledButton = styled.button`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border: none;
    border-radius: 28px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #007dff;
    color: #ffffff;
`;

export const StyledButtonIcon = styled.span`
    margin-right: 8px;
    font-size: 24px;
    line-height: 32px;
`;

export const StyledButtonText = styled.span`
    font-size: 15px;
    line-height: 15px;
`;
